export function initSwiper(selector) {

    import(/* webpackChunkName: "wp-swiper-bundle" */ 'swiper/bundle').then(SwiperModule => {
        
        const Swiper = SwiperModule.default;

        selector.forEach((element, i) => {

            const pagination   = document.querySelectorAll('.navDrop__teasers .swiper-pagination');
            const actionButton = document.querySelectorAll('.navDrop__teasers .swiper-actionButton');
            let   isAutoplaying = true;

            const swiper = new Swiper(element, {
            
                loop: true,
                effect: 'fade',
                autoplay: {
                    delay: 6000,   
                },
                speed: 1000,
                slidesPerView: 1,
                initialSlide: 0,
                spaceBetween: 40,
                pagination: {
                    el: pagination[i],
                    clickable: true,
                },
            });

            actionButton[i].addEventListener('click', () => {
                if (isAutoplaying) {
                    swiper.autoplay.stop();
                    actionButton[i].classList.add('swiper-button--play');
                    actionButton[i].classList.remove('swiper-button--pause');
                } else {
                    swiper.autoplay.start();
                    actionButton[i].classList.remove('swiper-button--play');
                    actionButton[i].classList.add('swiper-button--pause');
                }
                isAutoplaying = !isAutoplaying;
            });

        });
    });
}